import Image from 'next/image';
import css from './CardWithIcon.module.scss';
import { svgSprite } from '../../hybrid/wrappers';
import classNames from 'classnames';

export default function CardWithIcon(props) {
    const {
        key,
        icon,
        customIcon,
        name,
        formatted_value,
        comparison_value,
        component,
        goNextSlide,
        goPrevSlide,
        customCss = {},
        deleted_value
    } = props;
    return (
        <div key={key} className={classNames(css.item, customCss?.wrapper)}>
            <Image
                className={css.itemImage}
                src={'/src/img/office/volume_shine.svg'}
                width={200}
                height={100}
                alt='Shine'
                quality={100}
            />
            <div className={css.content}>
                <div className={classNames(css.icon, customCss?.icon)}>
                    {customIcon ? customIcon : svgSprite(icon, { className: classNames(css.svgIcon, customCss?.svgIcon) })}
                </div>
                {name ? <p className={css.title}>{name}</p> : null}
                <p className={css.valueWrapper}>
                    <span className={classNames(css.value, customCss.value)}>
                        {formatted_value}
                        {+deleted_value ? (
                            <div className={css.deletedValue}>
                                <p>{deleted_value}</p>
                            </div>
                        ) : null}
                    </span>
                    {comparison_value ? (
                        <>
                            <span className={css.comparisonValue}>{comparison_value}</span>
                        </>
                    ) : null}
                </p>
                {component && component}
                {goNextSlide || goPrevSlide ? (
                    <div className={css.sliderBtns}>
                        <div onClick={goPrevSlide} className={classNames('circleButton', css.sliderBtn)}>
                            {svgSprite('angle-left')}
                        </div>
                        <div onClick={goNextSlide} className={classNames('circleButton', css.sliderBtn)}>
                            {svgSprite('angle-right')}
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
}
